import { render, staticRenderFns } from "./ShippingCreate.vue?vue&type=template&id=383e60e0"
import script from "./ShippingCreate.vue?vue&type=script&lang=js"
export * from "./ShippingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports